import styles from "./Experience.module.css";
import { useState } from "react";

function Experience({ experience }) {
  const [experienceClicked, setExperienceClicked] = useState(false);
  return (
    <>
      {!experienceClicked || !experience.video? (
        <div
          onClick={() => {
            setExperienceClicked(true);
          }}
          className={styles.experience}
        >
          <img src={experience.image} alt="enterprise" />
          <div className={styles.content}>
            <h1>{experience.title}</h1>
            <h2>{experience.mission}</h2>
            <h3>{experience.goal}</h3>
            <h4>{experience.technologies}</h4>
          </div>
          <h2 className={styles.period}>{experience.period}</h2>
        </div>
      ) :(
        <div
          onClick={() => {
            setExperienceClicked(false);
          }}
          className={styles.video}
        >
          <iframe
            src={experience.video}
            allow="autoplay"
            title="experience"
          ></iframe>
        </div>
      )}
    </>
  );
}
export default Experience;
